export enum UserTypes {
  SuperAdministrator,
  Administrator,
  Helpdesk,
  Chef,
  Owner,
  Guest,
}
